import * as React from "react";
import { forwardRef } from "react";
const SvgArrow = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.16667 5.83325L5 9.99992M9.16667 14.1666L5 9.99992M5 9.99992H15", stroke: "#F2F2F3", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrow);
export default ForwardRef;
